import React from 'react';
import { Stack, StackItem, Text } from '@fluentui/react';

interface ITermsAndConditionsComponentProps {};

const TermsAndConditionsComponent = (props: ITermsAndConditionsComponentProps) => {
    return (
        <Stack>
            <StackItem>
                <Text 
                    variant="large"
                    className='fw-bold'>
                    Condiciones de contratación (v1.0)
                </Text>
            </StackItem>
            <StackItem>
                <Text variant='small'>
                    (Válidas desde 1/9/2022)
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text
                    variant='large'
                    className='fw-bold '>
                    Prestador de servicios
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    AMEDIDA TI SL, con CIF B73374316 y domicilio en C/ ANTONIO MACHADO, 51 – BAJO 2 -LAS TORRES DE COTILLAS - MURCIA. Datos de contacto: Teléfono 
                    968 387 397 – Email: info@amedidati.com. En adelante, prestador de servicios.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Parte contratante
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    Empresa o profesional que contrata el uso de aplicación en la nube MyMov para la gestión de quipos y tareas. En adelante, CLIENTE.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Descripción del producto y servicio contratado
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    MyMov es una aplicación informática en la nube para la gestión de equipos y tareas. El software está implementado en un sistema de plataforma online y se 
                    comercializa mediante cesión de uso por suscripción con cuota mensual por usuario. El nombre comercial es MyMov.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Definiciones
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    A los exclusivos efectos de este contrato, se entenderá por:
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <ol className='m-0'>
                    <li>
                        <Text className='fw-bold'>
                            Aplicación informática:
                        </Text> <Text>
                            Secuencia de instrucciones con destino a su interpretación, utilización y ejecución por un sistema informático. Aun cuando sean 
                            varias, el contrato podrá referirse a las mismas en singular, y se denominará como tal su copia de seguridad.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Aplicación en la nube:
                        </Text> <Text>
                            Aplicación informática que reside total o parcialmente en un servidor conectado a Internet tal que el acceso a la misma se produce 
                            remotamente a través de redes electrónicas y que puede ser utilizada por el usuario sin que se produzca la instalación completa del 
                            programa de ordenador en su computadora. La cesión del uso de la aplicación en la nube MyMov es el objeto del presente contrato.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Cliente de la aplicación en la nube:
                        </Text> <Text>
                            La persona física o jurídica beneficiaria de la cesión, y habilitada para el uso de la aplicación en la nube, la cual asume las 
                            obligaciones del presente contrato.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Usuario de la aplicación en la nube:
                        </Text> <Text>
                            La persona física autorizada por el cliente para el uso de la aplicación en la nube, la cual asume las obligaciones del presente 
                            contrato en cuanto a dicha utilización.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Partes:
                        </Text> <Text>
                            MyMov y el cliente.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Titular de los derechos de explotación de la aplicación en la nube:
                        </Text> <Text>
                            Amedida TI , domiciliada en C/ ANTONIO MACHADO, 51 - BAJO – 30565 LAS TORRES DE COTILLAS – MURCIA, con CIF B73374316 e inscrita en 
                            el Registro Mercantil de Murcia, tomo 22413, folio 128, hoja MU-52564.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Tercero:
                        </Text> <Text>
                            Aquella persona física o jurídica extraña a la presente relación contractual que por cualquier motivo se relacione obligacionalmente 
                            con MyMov o con el cliente.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Hardware:
                        </Text> <Text>
                            Dispositivos electrónicos, mecánicos o magnéticos necesarios para el funcionamiento de la aplicación en la nube y complementarios de 
                            la misma.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Dato personal:
                        </Text> <Text>
                            Toda información referida a una persona física identificada o identificable.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            Actualizaciones:
                        </Text> <Text>
                            Nuevas versiones de la aplicación en la nube y/o de los módulos de la misma, que incluyen nuevas funcionalidades y mejoras respecto 
                            a versiones anteriores.
                        </Text>
                    </li>
                </ol>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Objeto del contrato
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    Mediante el registro como usuario en el sitio web MyMov.app, dicho usuario confirma haber leído y comprendido los términos y condiciones 
                    generales. Al registrarse aprueba estos términos y condiciones generales quedando legalmente obligado y vinculado contractualmente a ellos. 
                    Asimismo, confirma explícitamente el conocimiento y obligación respecto de las tarifas vigentes.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El Acuerdo entre el usuario y MyMov se hace efectivo desde el momento del registro en el sitio web MyMov.app.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El objeto de dicho contrato es la cesión del derecho de uso sobre la aplicación en la nube n la nube MyMov por parte del prestador de 
                    servicios en beneficio de la parte contratante, para la gestión de equipos y tareas de forma propio o de terceros, por la cual, sujeto a los 
                    términos y condiciones de contratación, y dentro de los límites establecidos en el presente contrato.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El prestador de servicios cede con carácter revocable, de no-exclusividad, no sub-licenciable y de forma intransferible, el derecho de uso 
                    de la aplicación en la nube MyMov (en adelante, “la aplicación en la nube”). El acceso a la aplicación en la nube es una cesión de uso y no 
                    una venta, de modo que el titular de la aplicación en la nube conserva la propiedad de la misma.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La modalidad elegida por la parte contratante será la que él mismo elija en la fase de contratación de cada licencia de uso y de acuerdo a 
                    las condiciones económicas expresadas en el presente contrato.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La aplicación en la nube residirá en los servidores de MyMov o de una tercera empresa contratada para tal efecto, y la parte contratante o 
                    usuario autorizado tendrá derecho a usarla “on-line” o de modo remoto a través de Internet. La parte contratante tiene derecho a usar la 
                    aplicación en la nube, de forma limitada, condicionada y subordinada a los límites recogidos en el presente contrato, a los términos y 
                    condiciones de uso, así como al tiempo de duración del mismo.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La parte contratante se compromete a utilizar la aplicación en la nube de conformidad con la ley, este contrato, así como con la moral y 
                    buenas costumbres generalmente aceptadas y el orden público.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Condiciones económicas y formas de pago
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    El precio, forma de pago, facturación y cobro de la cesión de uso sobre la aplicación en la nube objeto del presente contrato son los siguientes:
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Los precios establecidos y publicados en la web en el momento de la contratación no incluyen el Impuesto sobre el Valor Añadido (IVA) ni otros impuestos 
                    o tasas que la ley establezca, que serán los vigentes para los servicios objeto del contrato en el momento de su firma. Por tanto, estas cantidades serán 
                    incrementadas con el importe correspondiente.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El prestador de servicios se reserva el derecho a revisar las tarifas, respecto al incremento anual del IPC, comunicando con antelación a la parte 
                    contratante. 
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    También pudieran producirse situaciones que requieran la implementación de cambios importantes en la estructura de funcionamiento de la aplicación en la 
                    nube que supongan incrementos en los costes del prestador de servicios, situación que pudiera dar lugar a un incremento de las tarifas de MyMov. Aunque 
                    esta situación podría darse en casos muy excepcionales, llegado el momento se comunicará con antelación a la parte contratante, estableciendo plazos para 
                    su consenso, aceptación y/o portabilidad, si así lo estima conveniente.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El importe facturado se hará efectivo mediante pago con tarjeta bancaria, transferencia anticipada o domiciliación bancaria (para esta última se debe 
                    solicitar autorización a prestador de servicios). 
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La demora o devolución del pago, total o parcial, por parte de la parte contratante de las cantidades facturadas por el prestador de servicios facultará 
                    a éste a suspender o cancelar las obligaciones adquiridas en virtud de este contrato. La suspensión del servicio se realizará en el momento de que se 
                    detecte la incidencia en el pago, y se comunicará inmediatamente a la parte contratante. Transcurridos quince días naturales desde la suspensión del 
                    servicio y previa comunicación a la parte contratante, el prestador de servicios podrá resolver este contrato. En el caso de que durante ese plazo el 
                    cliente satisfaga la totalidad de la deuda, el prestador de servicios restablecerá el servicio en el menor plazo posible desde la fecha en que ha tenido 
                    conocimiento de que se ha satisfecho el pago de la cantidad adeudada. El usuario asumirá cualquier gasto derivado de la reclamación y cobro de cualquier 
                    cantidad adeudada pasado el vencimiento de la factura, incluyendo, pero no limitado, a los gastos de devolución de recibos, intereses de demora y costas 
                    judiciales.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Duración
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    El presente contrato tendrá una duración indefinida, hasta que alguna de las partes manifieste su voluntad de rescisión del mismo 
                    comunicándosela a la otra con una antelación mínima de un mes.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El preaviso al que se refiere el apartado anterior no exonerará a las partes del cumplimiento de las obligaciones que les resulten exigibles.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Limitaciones de uso y deber de custodia
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    La parte contratante deberá proteger y custodiar la aplicación en la nube, no pudiendo ceder a terceros los derechos adquiridos mediante el 
                    presente contrato, ni permitir, por título o circunstancia alguna su uso por terceras personas o entidades no autorizadas, quedándole en 
                    definitiva prohibida la utilización de la aplicación en la nube para cualquier otro fin que no esté incluidos en los términos y condiciones 
                    generales.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Los usos permitidos y descritos en el punto anterior suponen que el prestador de servicios únicamente prestará soporte a la parte 
                    contratante y no se atenderá petición de soporte o consulta alguna por parte de sus clientes, franquiciados, asociados o colaboradores que 
                    no sean comunicadas directamente por la parte contratante. Por tanto, los usos descritos no implicarán arrendamiento, venta o 
                    sub-licenciamiento de la aplicación en la nube o la realización de actos que impliquen una violación del deber de protección de un bien, 
                    propiedad de tercero.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La parte contratante debe disponer y se hace responsable de obtener el consentimiento de todos los clientes, franquiciados, asociados o 
                    colaboradores de los que se gestionen datos a través de la aplicación en la nube MyMov. Dichos consentimientos deben ser acordes a la 
                    normativa vigente de Protección de Datos.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La parte contratante se obliga a abstenerse de utilizar la aplicación en la nube con fines o efectos ilícitos, contrarios a lo establecido 
                    en el presente documento y en la aplicación en la nube, lesivos de los derechos e intereses del prestador de servicios, del titular de la 
                    aplicación en la nube y de terceros, o que de cualquier forma puedan dañar, inutilizar, sobrecargar o deteriorar la aplicación en la nube o 
                    impedir la normal utilización o disfrute de la aplicación en la nube por parte de los demás clientes o usuarios.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    A la parte contratante le queda prohibido, de forma enunciativa pero no limitativa, realizar ingeniería inversa, descompilar, desensamblar, 
                    reproducir, traducir, modificar, versionar, comercializar, duplicar, transformar ni transmitir a persona o entidad, parcialmente o en su 
                    totalidad, en forma o por medio alguno, ya sea mecánico, magnético, por fotocopia o cualquier otro, o eliminar cualquier aviso de propiedad 
                    o etiquetas de la aplicación en la nube.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La parte contratante o usuario autorizado deberá proteger y custodiar física y lógicamente la aplicación en la nube, sus contenidos, 
                    procedimientos lógicos y los mecanismos de acceso, y proveerá los medios necesarios para garantizar, de forma enunciativa pero no limitativa, 
                    la no-divulgación, copiado, duplicado, manipulado, reproducción, traducción, transformación, acceso por parte de terceras personas o 
                    cualquier otro acto que impliquen una violación del deber de protección de un bien propiedad de tercero.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    Interpretación del alcance:
                </Text>
                <Text>
                    Todos los derechos que no se expongan o no hayan sido mencionados de forma expresa en el presente contrato, quedan reservados al prestador 
                    de servicios sin que las disposiciones contenidas en el mismo puedan interpretarse de manera que permitan que, de cualquier forma, su 
                    aplicación perjudique al prestador de servicios o sea contraria a una explotación normal de la aplicación en la nube.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Derecho de desistimiento y devoluciones
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    Dada la naturaleza de la contratación de los servicios del software MyMov, nos es imposible ofrecer la posibilidad del derecho a desistir 
                    de su contratación. Esto es debido a que, una vez contratado, no podemos determinar si se ha hecho uso de la licencia contratada o no, por 
                    lo que no podemos realizar devoluciones. A cambio hemos implementado sistemas de confirmación de contratación, para evitar contrataciones 
                    accidentales. No obstante, si ha realizado una contratación erróneamente, póngase en contacto con nuestro equipo para analizar si es posible 
                    subsanarlo o no, aunque esto no se considerará un compromiso unilateral.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Responsabilidad
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    El prestador de servicios posibilita el acceso a la aplicación en la nube en su configuración y estado actual. En caso de contener la 
                    aplicación alguna deficiencia atribuible al prestador de servicios, éste se compromete a utilizar todos los medios a su alcance para 
                    solucionarlo a la mayor brevedad posible, pero no se hace responsable ni concede garantías de ninguna clase con relación a la violación de 
                    derechos de terceros, comerciabilidad, calidad satisfactoria o idoneidad para un fin determinado.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El prestador de servicios garantiza, en lo que respecta a los medios y sistemas bajo su control, la disponibilidad de la aplicación en la 
                    nube a través de la red y equipos de su responsabilidad. Sin embargo, el prestador de servicios no se hace responsable de interrupciones y 
                    deterioros en la calidad de la disponibilidad del servicio por causas que escapen al control del prestador de servicios, y de forma 
                    enunciativa pero no limitativa, por causas atribuibles a fallos en las infraestructuras informáticas del cliente y/o usuarios, fallos 
                    atribuibles a proveedores de servicios del prestador de servicios, causas de fuerza mayor u otros motivos que escapen al control del 
                    prestador de servicios o que no sean razonablemente predecibles. La responsabilidad del prestador de servicios por cualesquiera daños y 
                    perjuicios de toda naturaleza que puedan deberse a la falta de disponibilidad o de continuidad de acceso a la aplicación en la nube estará 
                    limitada al importe económico que debe abonar la parte contratante, como contraprestación por la cesión de uso de la aplicación en la nube 
                    durante el tiempo de alteración del servicio, en base a lo establecido en el párrafo siguiente y en las Tarifas Oficiales Vigentes publicadas 
                    en la página web MyMov.app.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Con el fin de garantizar el buen funcionamiento del servicio, el prestador de servicios se reserva el derecho de efectuar pruebas, ajustes y 
                    operaciones de mantenimiento en sus instalaciones, equipos y aplicaciones, pudiendo facilitar el acceso a la aplicación en la nube por parte 
                    de la parte contratante a través de una ruta de comunicación electrónica alternativa o, en caso de que esto no sea posible, suspender 
                    temporalmente dicho acceso. El prestador de servicios se reserva el uso exclusivo de la clave de administrador del sistema y de la aplicación 
                    en la nube con el único fin de realizar tales operaciones de mantenimiento. El prestador de servicios podrá realizar las operaciones de 
                    mantenimiento previstas, con la previa comunicación la parte contratante. En ningún caso estas operaciones de mantenimiento, siempre que 
                    sean notificadas previamente a la parte contratante, se entenderán como fallos o deterioros en la disponibilidad del servicio de la 
                    aplicación en la nube.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El prestador de servicios actuará con la debida diligencia y profesionalidad, poniendo todos los medios a su alcance para que el acceso a 
                    la aplicación en la nube objeto de este contrato esté disponible con los mayores niveles de calidad, fiabilidad y seguridad. En cualquier 
                    caso, la responsabilidad del prestador de servicios, por cualesquiera daños directos o indirectos, consiguientes, incidentales o especiales, 
                    incluyendo, de forma enunciativa pero no limitativa, cualquier daño emergente o lucro cesante, interrupción del trabajo, avería, fallo o 
                    perdidas, incluso en el caso de que se haya notificado a un representante del prestador de servicios la posibilidad de que ocurran tales 
                    daños, o por cualquier reclamación por parte de terceros, estará limitada, en todo caso, al importe económico equivalente al que debe abonar 
                    la parte contratante, como contraprestación por la cesión de uso de la aplicación en la nube durante el tiempo de alteración del servicio, 
                    en su caso, en base a lo establecido en las Tarifas Oficiales Vigentes publicadas en la página web MyMov.app.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La parte contratante o usuario será el único responsable de la provisión y el pago de costes necesarios para asegurar la compatibilidad con 
                    la aplicación en la nube relacionados con los equipos, incluyendo todo el hardware, software, componentes eléctricos y otros componentes 
                    físicos requeridos para acceder y usar la aplicación en la nube incluyendo de forma enunciativa pero no limitativa servicios de 
                    telecomunicaciones, acceso y conexión a Internet, sistemas operativos, u otros programas, equipos y servicios requeridos para acceder y 
                    usar la aplicación en la nube.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Derecho de modificación
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    El prestador de servicios se reserva el derecho de actualizar la aplicación en la nube de la parte contratante a las últimas versiones 
                    disponibles en el mercado, con nuevas funcionalidades, mejoras, modificaciones y actualizaciones legales de la misma, variando en cualquier 
                    momento la presentación, configuración y contenido de la aplicación en la nube. El prestador de servicios se compromete a tener en cuenta 
                    las sugerencias y peticiones de los usuarios de la aplicación en la nube para el desarrollo de nuevas versiones de la misma, pero corresponde 
                    al prestador de servicios y no a la parte contratante la decisión de cuáles son las modificaciones y mejoras a incluir en dichas versiones.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El prestador de servicios se reserva el derecho a cambiar las condiciones de uso en cualquier momento, comunicando dichos cambios a través 
                    de la página web (MyMov.app). Las contrataciones ya realizadas antes de la fecha de la nueva publicación de los Términos y Condiciones de 
                    contratación, se regirán por la que la parte contratante aceptó en el momento de la contratación o renovación. No obstante, cada vez que el 
                    usuario renueve o realice una nueva contratación, será notificado para la lectura y aceptación de la última versión de los términos y 
                    condiciones de contratación.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Exclusión y resolución de la cesión de uso
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    El prestador de servicios se reserva el derecho de excluir y/o resolver, temporal o definitivamente al cliente en relación con la cesión de 
                    uso en cualquiera de los siguientes supuestos:
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <ol className='m-0'>
                    <li>
                        <Text>
                            Por incumplimiento de cualquiera de los términos y condiciones establecidos en el presente documento.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            Por incumplimiento de las leyes, la moral o el Orden público.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            Por orden o requerimiento de la autoridad u órgano competente.
                        </Text>
                    </li>
                </ol>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La exclusión de la parte contratante o usuario o la resolución de la cesión de uso no supondrá la renuncia del prestador de servicios a 
                    realizar las acciones legales correspondientes o las indemnizaciones que correspondan en caso de que la parte contratante hubiera actuado 
                    deliberadamente de mala fe, para dañar la aplicación en la nube o para perjudicar de modo directo o indirecto al prestador de servicios.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Comunicaciones
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    Para la práctica de cualesquiera notificaciones en relación con el presente contrato, el prestador de servicios pone a disposición de la 
                    parte contratante los medios para que comunique sus datos en el momento de dar de alta el servicio, debiendo comunicarse, de forma 
                    fehaciente, su cambio.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La falta de dicha comunicación implicará que no se considerarán válidas las notificaciones efectuadas en dichas plataformas.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Extinción
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    El presente Contrato se extinguirá por las causas generales establecidas en el Código Civil y en el Código de Comercio y en especial, por 
                    incumplimiento de las obligaciones dimanantes de este escrito:
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <ol className='m-0'>
                    <li>
                        <Text>
                            Por la rescisión unilateral de una parte mediante comunicación a la otra con un preaviso mínimo de un mes, motivadas por 
                            incumplimiento de contrato.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            Por ser declarada cualquiera de las partes en estado judicial de suspensión de pagos, quiebra o concurso de acreedores, fuese 
                            demostrada una situación de insolvencia o cese de actividades, o se iniciase un proceso de liquidación o disolución.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            Por las demás causas previstas en derecho.
                        </Text>
                    </li>
                </ol>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    En caso de incumplimiento por alguna de las partes de las obligaciones asumidas en el presente contrato, la otra parte podrá dar por 
                    resuelto enteramente el mismo, sin preaviso ni indemnización de clase alguna, siendo suficiente la comunicación de tal rescisión a la parte 
                    contraria, a no ser que la parte incumplidora remediase su incumplimiento a satisfacción de la otra en un plazo de 15 días contado desde el 
                    requerimiento que en tal sentido se efectúe, sin perjuicio de las indemnizaciones que, por daños o perjuicios, puedan corresponder.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El prestador de servicios se compromete a destruir los datos facilitados por la parte contratante una vez extinguida la relación contractual. 
                    Será responsabilidad de la parte contratante responsable del tratamiento descargar la información de MyMov <Text className='fw-bold'>
                        ANTES
                    </Text> de la rescisión del servicio, si desea conservarla en sus propios equipos y soportes.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Propiedad intelectual e industrial
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    Los derechos de explotación de la aplicación en la nube son titularidad del prestador de servicios y están protegidos por las Leyes de 
                    Propiedad Intelectual españolas y por las leyes aplicables del país donde se utilice. La estructura, organización y codificación de la 
                    aplicación en la nube constituyen valiosos secretos comerciales e información confidencial del prestador de servicios. Así la parte 
                    contratante deberá, por tanto, tratar la Aplicación informática de la misma forma que haría con cualquier otro material con derechos de 
                    propiedad intelectual y no podrá copiar la aplicación en la nube.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La concesión de la presente cesión de uso no implica, implícita ni explícitamente, la cesión de los derechos sobre las propiedades 
                    industrial e intelectual de la aplicación en la nube, el hardware, o sobre el modelo de datos.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Las marcas deberán utilizarse de conformidad con los usos comerciales sobre marcas, incluida la mención del nombre del propietario de la 
                    marca. Las marcas sólo pueden utilizarse para identificar los impresos producidos por la aplicación en la nube. Esta utilización de cualquier 
                    marca no implica la concesión de ningún derecho de propiedad sobre la misma.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Los conocimientos y la experiencia inherentes a la aplicación en la nube, así como los conocimientos utilizados para la configuración de la 
                    aplicación en la nube, son información propia y confidencial del titular de la aplicación en la nube y del prestador de servicios. La parte 
                    contratante lo reconoce y asume la responsabilidad por el uso fraudulento o copia ilegal de la aplicación en la nube o programas accesorios, 
                    o de estas informaciones por terceros, y se hará responsable de cualquier infracción cometida por quien de él dependa o por cuya causa haya 
                    conocido o tenido acceso directo o indirecto a la aplicación en la nube.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    Actualizaciones:
                </Text> <Text>
                    Durante el tiempo de duración del presente contrato y sujeto a los términos y condiciones recogidas en el párrafo siguiente, la parte 
                    contratante tendrá derecho a disponer de las actualizaciones que, de la aplicación en la nube, objeto del presente contrato, vayan surgiendo, 
                    asumiendo sobre las mismas idéntico compromiso en cuanto a sus limitaciones de uso y deber de custodia que sobre la aplicación informática 
                    original.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Protección de datos
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    Las partes manifiestan que conocen, cumplen y se someten de forma expresa a la legislación española y europea en materia de Protección de 
                    Datos de Carácter Personal, comprometiéndose a dar un uso debido a los datos de tal naturaleza que obtengan como consecuencia del desarrollo 
                    del presente contrato.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    En concreto, de acuerdo con lo expresado en el artículo 12 de la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de 
                    Carácter Personal, y los artículos 28 y 29 del Reglamento Europeo de Protección de Datos (UE 2016/679) del 27 de abril de 2016, no será 
                    considerado comunicación ni cesión de datos al acceso por el prestador de servicios a los datos de carácter personal de los ficheros de la 
                    parte contratante («responsable del tratamiento») ya que dicho acceso, y el correspondiente tratamiento, es necesario para realizar la 
                    prestación del servicio contratado.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Por ello y a los efectos de normativa de protección de datos, el prestador de servicios será considerado como «encargado del tratamiento» de 
                    los datos del cliente y, de acuerdo con ello, se establece expresamente que el prestador de servicios únicamente tratará los datos conforme 
                    a las siguientes instrucciones:
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <ol className='m-0'>
                    <li>
                        <Text className='fw-bold'>
                            FINALIDADES:
                        </Text> <Text>
                            El Encargado del Tratamiento únicamente podrá utilizar los datos personales objeto de este contrato y los incluidos en la plataforma 
                            MyMov, para prestar soporte técnico al Responsable del Tratamiento ante posibles incidencias de la plataforma contratada (MyMov)
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            DEVOLUCIÓN DE LOS DATOS:
                        </Text> <Text>
                            Una vez cumplida la prestación de servicios pactada, y cuando ya no sean necesarios para continuar con el encargo realizado, los 
                            datos de carácter personal serán destruidos, por lo que será responsabilidad de la parte contratante la responsabilidad de descargar 
                            la información del MyMov ANTES de la rescisión del servicio, si desea conservarla en sus propios equipos y soportes.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            CESIONES A TERCEROS:
                        </Text> <Text>
                            El encargado del tratamiento no cederá los datos a terceras personas u organizaciones.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            TRANSFERENCIA INTERNACIONAL DE DATOS:
                        </Text> <Text>
                            No están previstas las comunicaciones de sus datos a terceros, salvo aquellas que son lícitas por obligación de cumplimiento legal. 
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            SUBCONTRATACIÓN:
                        </Text> <Text>
                            Para el desarrollo de los servicios implícitos en la relación de prestación de servicios entre ambas organizaciones, no se permite 
                            la subcontratación de ninguna entidad tercera, salvo aquellos servicios auxiliares necesarios para el normal funcionamiento del 
                            ejercicio de las actividades de la organización prestataria.
                        </Text>
                    </li>
                    <li>
                        <Text className='fw-bold'>
                            BRECHAS DE SEGURIDAD:
                        </Text> <Text>
                            El Encargado del Tratamiento notificará al Responsable del Tratamiento, las violaciones de la seguridad de los datos personales a su 
                            cargo de las que tenga conocimiento, juntamente con toda la información relevante para la documentación y comunicación de la 
                            incidencia, todo ello sin la dilación indebida, en un plazo máximo de 48 horas, en un lenguaje claro y sencillo y, en cualquier caso, 
                            de acuerdo con las siguientes pautas:
                        </Text>
                        <ol className='m-0'>
                            <li>
                                <Text>
                                    No será necesaria la notificación cuando sea improbable que dicha violación de la seguridad constituya un riesgo para los derechos y 
                                    las libertades de las personas físicas.
                                </Text>
                            </li>
                            <li>
                                <Text>
                                    Si se dispone de ella, se facilitará como mínimo, la siguiente información:
                                </Text>
                                <ol className='m-0'>
                                    <li>
                                        <Text>
                                            Descripción de la naturaleza de la violación de la seguridad de los datos personales, inclusive, cuando sea posible, 
                                            las categorías y el número aproximado de interesados afectados, y las categorías y el número aproximado de registros 
                                            de datos personales afectados.
                                        </Text>
                                    </li>
                                    <li>
                                        <Text>
                                            Los datos de contacto en el que se pueda obtener más información.
                                        </Text>
                                    </li>
                                    <li>
                                        <Text>
                                            Descripción de las posibles consecuencias de la violación de la seguridad de los datos personales.
                                        </Text>
                                    </li>
                                    <li>
                                        <Text>
                                            Descripción de las medidas adoptadas o propuestas para poner remedio a la violación de la seguridad de los datos 
                                            personales, incluyendo, si procede, las medidas adoptadas para mitigar los posibles efectos negativos.
                                        </Text>
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                </ol>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Confidencialidad
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    Los conocimientos y demás informaciones transmitidas entre las partes constituyen información propia y confidencial del prestador de 
                    servicios y la parte contratante y su protección es de la máxima importancia. Por ello, ambas partes asumen la obligación de guardar dicha 
                    información como confidencial, adoptando las medidas apropiadas para asegurar que solamente aquellas personas autorizadas tengan acceso a la 
                    misma, entendiendo como personas autorizadas aquellos empleados de las partes que lo necesiten para el desarrollo de la actividad objeto de 
                    este acuerdo.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    De este modo, las partes firmantes aceptan el siguiente COMPROMISO DE CONFIDENCIALIDAD:
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fst-italic'>
                    El prestador de servicios se compromete a mantener confidencial toda aquella información relativa a la parte contratante suministrada por 
                    éste con tal carácter, así como el producto de los servicios encomendados. En este sentido, el prestador de servicios tiene establecidos 
                    estrictos controles internos cuyo objetivo y finalidad es garantizar este compromiso de confidencialidad. La parte contratante se compromete 
                    a mantener confidencial toda la información y conocimiento que obtenga de los procesos internos de la parte contratante y en especial la 
                    existencia, utilización y funciones de cualquier proceso utilizado en el desempeño de sus prestaciones.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El presente Compromiso de Confidencialidad se mantendrá vigente incluso después de extinguida la presente relación contractual y respecto a 
                    todo el personal que haya tenido acceso a dicha información confidencial, con carácter indefinido.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Integridad del contrato y cláusula de salvaguarda
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    Cada una de las estipulaciones del presente acuerdo debe ser interpretada separada e independientemente de las demás. Si cualesquiera de 
                    ellas pasaren a ser inválidas, ilegales o inejecutables en virtud de alguna norma jurídica o fuera declarada nula o ineficaz por cualquier 
                    juzgado o autoridad administrativa, la nulidad o ineficacia de la misma no afectará las demás estipulaciones, que conservarán su plena 
                    validez y eficacia. Las partes contratantes acuerdan sustituir la cláusula o cláusulas afectadas por otra u otras que tengan los efectos 
                    correspondientes a los fines perseguidos por las partes en el presente contrato.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El presente contrato recoge la totalidad de los pactos existentes entre las partes, y anula y revoca, en su caso, cuantos otros pactos o 
                    acuerdos, verbales o escritos, estuvieren vigentes a la fecha de su suscripción. El presente contrato podrá ser modificado en cualquier 
                    momento. Será publicada una versión revisada por parte del prestador de servicios SL a través de la página web (MyMov.app). Los términos 
                    modificados serán efectivos una vez publicados o, en caso de ser notificados por correo electrónico, se establecerá de acuerdo a lo 
                    estipulado en el mensaje de correo. El uso de la aplicación una vez se han hecho efectivas las notificaciones del contrato implica la 
                    aceptación por parte de la parte contratante de la modificación de los términos. Es responsabilidad de la parte contratante revisar de forma 
                    regular los términos de contrato, publicados en el sitio web (MyMov.app). La fecha de la última revisión del contrato se encuentra registrada 
                    en el principio de este documento.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text 
                    variant='large'
                    className='fw-bold'>
                    Legislación aplicable y jurisdicción
                </Text>
            </StackItem>
            <StackItem>
                <Text>
                    El presente contrato tiene carácter mercantil, y se regirá por la ley española. Las partes intervinientes acuerdan que todo litigio, 
                    discrepancia, cuestión o reclamación resultante de la ejecución o interpretación del presente contrato o relacionado con él, directa o 
                    indirectamente, se resolverán mediante sometimiento a los Juzgados y Tribunales de Murcia, España con renuncia expresa a cualquier otro 
                    fuero. Constituye este contrato la expresión completa e íntegra del acuerdo entre las partes, y sustituye todos los anteriores pactos, 
                    compromisos, manifestaciones o acuerdos, tanto escritos como orales, que hayan existido previamente entre las partes.
                </Text>
            </StackItem>
        </Stack>
    );
};

export default TermsAndConditionsComponent;
